<div class="ff" (click)="cancelar()" (keydown.enter)="$event.target === $event.currentTarget ? cancelar() : null">
  <div class="ff__caja" role="dialog" aria-modal="true" aria-labelledby="ff-titulo" (click)="$event.stopPropagation()" (keydown.enter)="$event.target === $event.currentTarget ? $event.stopPropagation() : null">
    <h3 class="ff__tit" id="ff-titulo">{{ titulo }}</h3>
    <p class="ff__quien" *ngIf="para === 'autorizar' && nombre">
      {{ etiquetaQuien }} <b>{{ nombre }}</b>
    </p>

    <!-- Las dos maneras de firmar. La digital va primero porque es la
         que cierra el trámite sin salir de aquí. -->
    <div class="ff__modos" role="tablist" *ngIf="!soloDigital">
      <button type="button" class="ff__modo" role="tab"
              [class.es-activo]="modo === 'digital'"
              (click)="cambiaModo('digital')">
        <span class="material-icons">draw</span>
        Firmar digital
      </button>
      <button type="button" class="ff__modo" role="tab"
              [class.es-activo]="modo === 'fisica'"
              (click)="cambiaModo('fisica')">
        <span class="material-icons">download</span>
        Descargar para firmar
      </button>
    </div>

    <p class="ff__texto">{{ explicacion }}</p>

    <ng-container *ngIf="modo === 'digital'">
      <canvas
        #lienzo
        class="ff__lienzo"
        width="600"
        height="240"
        (pointerdown)="empieza($event)"
        (pointermove)="mueve($event)"
        (pointerup)="termina()"
        (pointercancel)="termina()"
      ></canvas>
      <span class="ff__guia">Firma con el mouse o con el dedo</span>
    </ng-container>

    <div class="ff__papel" *ngIf="modo === 'fisica'">
      <span class="material-icons">description</span>
      <div>
        <b>{{ docTitulo }}</b>
        <span>{{ textoPapel }}</span>
      </div>
    </div>

    <!-- Lo que quien abre el cuadro necesita junto a la firma (Homologación: el PIN). -->
    <ng-content></ng-content>

    <div class="ff__acciones">
      <button type="button" class="ff__btn" *ngIf="modo === 'digital'" [disabled]="ocupado" (click)="limpiar()">
        <span class="material-icons">backspace</span>
        Limpiar
      </button>
      <span class="ff__aire"></span>
      <button type="button" class="ff__btn" [disabled]="ocupado" (click)="cancelar()">Cancelar</button>
      <button type="button" class="ff__btn ff__btn--ok"
              [disabled]="!puedeConfirmar"
              (click)="confirmar()">
        <span class="material-icons">{{ modo === 'fisica' ? 'download' : 'draw' }}</span>
        {{ textoBoton }}
      </button>
    </div>
  </div>
</div>
